import React from 'react';
import classNames from 'classnames';
import './_switchButton.scss';

type SwitchButtonProps = {
  isOn: boolean;
  handleToggle: () => void;
};

const SwitchButton: React.FC<SwitchButtonProps> = ({ isOn, handleToggle }) => {
  const labelClass = classNames({
    'switch__label female': isOn,
    'switch__label male': !isOn,
  });
  return (
    <React.Fragment>
      <div className="switch__label-info">
        <span>Male</span>
        <span>Female</span>
      </div>
      <input
        checked={isOn}
        onChange={handleToggle}
        className="switch__checkbox"
        id={`switch-new`}
        type="checkbox"
      />
      <label className={labelClass} htmlFor={`switch-new`}>
        <span className={`switch__button`} />
      </label>
    </React.Fragment>
  );
};

export default SwitchButton;
